export default __webpack_public_path__ + "static/media/person_2.898dcc54.png";